export type TariffBenefit = {
  title: string;
  text: string;
};
export type Tariff = {
  name: string;
  monthPrice: number;
  benefits: TariffBenefit[];
};

export const YEAR_DISCOUNT_PERCENT = 23;
export const tariffs: Tariff[] = [
  {
    name: 'Бесплатный',
    monthPrice: 0,
    benefits: [
      {
        title: 'Размещение в списке',
        text: '',
      },
      {
        title: 'Прямо на карте',
        text: '',
      },
      {
        title: 'Твое напоминание',
        text: '',
      },
      {
        title: 'Рабочее расписание',
        text: '',
      },
      {
        title: 'История записей',
        text: '',
      },
      {
        title: 'Честный отзыв',
        text: '',
      },
      {
        title: 'Работа с отзывами',
        text: '',
      },
      {
        title: 'Напоминание клиенту',
        text: '',
      },
      {
        title: 'Круглосуточная запись клиента',
        text: '',
      },
      {
        title: 'Профиль',
        text: '',
      },
      {
        title: 'Проверка фотографии',
        text: '',
      },
      {
        title: 'Создание пауз',
        text: '',
      },
      {
        title: 'Чат с клиентами',
        text: '',
      },
      {
        title: 'Черный список',
        text: '',
      },
      {
        title: 'Делитесь контактами',
        text: '',
      },
      {
        title: 'Много информации',
        text: '',
      },
      {
        title: 'Приятное клиентам',
        text: '',
      },
      {
        title: 'Общий чат',
        text: '',
      },
      {
        title: 'Интеграция с соцсетями',
        text: '',
      },
      {
        title: 'Заметки',
        text: '',
      },
      {
        title: 'Простое управление',
        text: '',
      },
    ],
  },
  {
    name: 'Платный 1',
    monthPrice: 169,
    benefits: [
      {
        title: '+ Тариф «Бесплатный»',
        text: '',
      },
      {
        title: 'Онлайн-чаевые',
        text: '',
      },
      {
        title: 'Аналитика доходов',
        text: '',
      },
      {
        title: 'Рассылка клиентам',
        text: '',
      },
      {
        title: 'Скидки клиентам',
        text: '',
      },
      {
        title: 'Статистика по услугам',
        text: '',
      },
      {
        title: 'Статистика по клиентам',
        text: '',
      },
      {
        title: 'Программа лояльности',
        text: '',
      },
      {
        title: 'Повторная запись',
        text: '',
      },
      {
        title: 'Личный менеджер',
        text: '',
      },
      {
        title: 'Бонусы',
        text: '',
      },
      {
        title: 'Сегментация клиентов',
        text: '',
      },
    ],
  },
  {
    name: 'Платный 2',
    monthPrice: 499,
    benefits: [
      {
        title: '+ Тариф «Платный 1»',
        text: '',
      },
      {
        title: 'Будь на главной',
        text: '',
      },
      {
        title: 'Привлечение новых',
        text: '',
      },
      {
        title: 'Не останься незамеченным',
        text: '',
      },
      {
        title: 'Не отвлекайся от работы',
        text: '',
      },
    ],
  },
];
